import React from "react";
import carBlogs from "../data/carBlogs";

const CarBlogSection = () => {
  return (
    <div className="car-blog-section">
      {carBlogs.map((blog) => (
        <div className="car-blog-card" key={blog.id}>
          <img src={blog.image} alt={blog.title} />
          <div className="content">
            <h3>{blog.title}</h3>
            <p className="meta">
              {blog.author} • {blog.date} 
            </p>
            <p>{blog.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CarBlogSection;
